angular.module('core').filter('count', ['numberFilter',
  function($numberFilter) {
    return function(input) {
      if(_.isUndefined(input) || !_.isNumber(input)) {
        return '0';
      }
      else {
        return $numberFilter(input);
      }
    };
  }
]);
